import { useContext } from 'react';
import { SearchStyle, Context as ConfigContext } from '../../Config';
import useSearchWithResultsPage from './useSearchWithResultsPage';
import useSearchWithDropdown from './useSearchWithDropdown';
function useSearch() {
    const { searchStyle = SearchStyle.resultsPage } = useContext(ConfigContext);
    // eslint disable because Config won't ever change, so we won't ever change the hook we are returning.
    if (searchStyle !== SearchStyle.resultsPage)
        return useSearchWithDropdown(); // eslint-disable-line react-hooks/rules-of-hooks
    return useSearchWithResultsPage(); // eslint-disable-line react-hooks/rules-of-hooks
}
export default useSearch;
//# sourceMappingURL=index.js.map